import { useDispatch, useSelector } from 'react-redux';

import appSelectors from 'redux/app/appSelectors';

import { setLanguage } from 'redux/app/appSlice';

import s from './btnLang.module.css';

function BtnLang() {
  const dispatch = useDispatch();
  const lang = useSelector(appSelectors.language);

  const toggleLang = () => {
    const nextLang = lang === 'ru' ? 'en' : 'ru';

    dispatch(setLanguage(nextLang));

    localStorage.setItem('vps24-language', nextLang);
  };

  return (
    <button
      type="button"
      onClick={toggleLang}
      className={s.btn_lang}
      title="language"
    >
      {lang}
    </button>
  );
}

export default BtnLang;
